import React, { ReactNode } from 'react'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import * as S from './styles'

type CardInputMessageProps = {
  title: string
  children: ReactNode
  isTextArea?: boolean
  isError?: boolean
}

const CardInputMessage = ({
  title,
  children,
  isTextArea = false,
  isError = false
}: CardInputMessageProps) => {
  return (
    <S.CardInputMessageWrapper>
      <HeadingNew
        color="neutral800"
        size="xsmall"
        weight="bold"
        lineHeight="medium"
      >
        {title}
      </HeadingNew>
      <S.CardInputMessageContent isTextArea={isTextArea} isError={isError}>
        {children}
      </S.CardInputMessageContent>
    </S.CardInputMessageWrapper>
  )
}

export default CardInputMessage
